"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = exports.updateMaps = exports.getAllTree = exports.getAll = exports.get = void 0;
var lodash_1 = __importDefault(require("lodash"));
var firebase = __importStar(require("../firebase/fbase"));
var UpdateContainer_1 = require("../utils/UpdateContainer");
var ControlManager = __importStar(require("./ControlManager"));
var RCMUtils_1 = require("./RCMUtils");
var get = function (id) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, firebase.dbService.collection(RCMUtils_1.CYCLE_COLLECTION_NAME).doc(id).get()];
            case 1: return [2 /*return*/, (_a.sent()).data()];
        }
    });
}); };
exports.get = get;
var getAll = function () { return __awaiter(void 0, void 0, void 0, function () {
    var collectionData;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, firebase.dbService.collection(RCMUtils_1.CYCLE_COLLECTION_NAME).get()];
            case 1:
                collectionData = _a.sent();
                return [2 /*return*/, lodash_1.default.map(collectionData.docs, function (docData) { return docData.data(); })];
        }
    });
}); };
exports.getAll = getAll;
var getAllTree = function () { return __awaiter(void 0, void 0, void 0, function () {
    var cycleDataAll;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, exports.getAll)()];
            case 1:
                cycleDataAll = _a.sent();
                return [2 /*return*/, lodash_1.default.map(lodash_1.default.groupBy(cycleDataAll, function (item) { return item.cycleNumber; }), function (groupCategory, cycleId) {
                        var _a;
                        var cycleName = ((_a = lodash_1.default.head(groupCategory)) === null || _a === void 0 ? void 0 : _a.cycleName) || '';
                        var categories = lodash_1.default.map(lodash_1.default.groupBy(groupCategory, function (item) { return item.categoryNumber; }), function (subcategories, categoryId) {
                            var headItem = lodash_1.default.head(subcategories);
                            var categoryName = (headItem === null || headItem === void 0 ? void 0 : headItem.categoryName) || '';
                            return {
                                id: categoryId,
                                name: categoryName,
                                parent: {
                                    id: cycleId,
                                    name: cycleName
                                },
                                children: lodash_1.default.sortBy(lodash_1.default.map(subcategories, function (item) { return ({
                                    id: item.subCategoryNumber,
                                    name: item.subCategoryName,
                                    parent: {
                                        id: categoryId,
                                        name: categoryName,
                                        parent: {
                                            id: cycleId,
                                            name: cycleName
                                        }
                                    },
                                    children: []
                                }); }), 'id')
                            };
                        });
                        return {
                            id: cycleId,
                            name: cycleName,
                            children: lodash_1.default.sortBy(categories, 'id')
                        };
                    })];
        }
    });
}); };
exports.getAllTree = getAllTree;
var updateMap = function (cycleId, updateObject) { return __awaiter(void 0, void 0, void 0, function () {
    var finalUpdateObject, cycleObject;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                finalUpdateObject = {};
                return [4 /*yield*/, (0, exports.get)(cycleId)];
            case 1:
                cycleObject = _a.sent();
                lodash_1.default.forEach(['processIds', 'riskIds', 'controlIds'], function (targetKey) {
                    var newIds = (0, UpdateContainer_1.applyUpdateIds)(cycleObject[targetKey], updateObject === null || updateObject === void 0 ? void 0 : updateObject[targetKey]);
                    lodash_1.default.set(finalUpdateObject, targetKey, newIds);
                });
                return [4 /*yield*/, firebase.dbService.collection(RCMUtils_1.CYCLE_COLLECTION_NAME).doc(cycleId).update(finalUpdateObject)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
var updateMaps = function (updateIdContainer) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.all(lodash_1.default.map(updateIdContainer.values(), function (updateIds, cycleId) { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, updateMap(cycleId, updateIds)];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                }); }))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.updateMaps = updateMaps;
var update = function (cycle) { return __awaiter(void 0, void 0, void 0, function () {
    var cycleId, docRef, cycleDataList, duplicateCheckForCycleId, duplicateCheckForCycleNumber, duplicateCheckForCycleName, newCycle;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                cycleId = lodash_1.default.join([cycle.cycleNumber, cycle.categoryNumber, cycle.subCategoryNumber], '-');
                docRef = firebase.dbService.collection(RCMUtils_1.CYCLE_COLLECTION_NAME).doc(cycleId);
                if (!cycle.isNew) return [3 /*break*/, 4];
                return [4 /*yield*/, (0, RCMUtils_1.isNotUniqueId)(cycleId)];
            case 1:
                if (_a.sent()) {
                    return [2 /*return*/, Promise.reject(new Error('이미 존재하는 아이디입니다.'))];
                }
                return [4 /*yield*/, (0, exports.getAll)()
                    // cycleId 가 이미 존재하는지 체크
                ];
            case 2:
                cycleDataList = _a.sent();
                duplicateCheckForCycleId = lodash_1.default.find(cycleDataList, { id: cycleId });
                if (!lodash_1.default.isUndefined(duplicateCheckForCycleId)) {
                    return [2 /*return*/, Promise.reject(new Error('이미 존재하는 대분류-중분류-소분류 아이디 입니다.'))];
                }
                duplicateCheckForCycleNumber = lodash_1.default.find(cycleDataList, { cycleNumber: cycle.cycleNumber });
                if (!lodash_1.default.isUndefined(duplicateCheckForCycleNumber)) {
                    if (duplicateCheckForCycleNumber.cycleName !== cycle.cycleName) {
                        // cycleNumber 가 일치하는 게 있고 cycleName 은 다른 경우
                        return [2 /*return*/, Promise.reject(new Error('같은 대분류 아이디에 대해서 다른 대분류 이름은 안됩니다.'))];
                    }
                }
                duplicateCheckForCycleName = lodash_1.default.find(cycleDataList, { cycleName: cycle.cycleName });
                if (!lodash_1.default.isUndefined(duplicateCheckForCycleName) &&
                    cycle.cycleNumber !== duplicateCheckForCycleName.cycleNumber) {
                    // 이미 cycleNumber 가 일치하는 건 없는 상황에서(위에서 체크했기 때문에) cycleName 만 같은 경우도 막는다
                    return [2 /*return*/, Promise.reject(new Error('다른 대분류 아이디에 대해서 같은 대분류 이름은 안됩니다.'))];
                }
                newCycle = {
                    id: cycleId,
                    cycleNumber: cycle.cycleNumber,
                    cycleName: cycle.cycleName,
                    categoryNumber: cycle.categoryNumber,
                    categoryName: cycle.categoryName,
                    subCategoryNumber: cycle.subCategoryNumber,
                    subCategoryName: cycle.subCategoryName,
                    processIds: [],
                    riskIds: [],
                    controlIds: []
                };
                return [4 /*yield*/, docRef.set(newCycle)];
            case 3:
                _a.sent();
                return [3 /*break*/, 6];
            case 4: 
            // 기존의 CYCLE 항목 수정
            return [4 /*yield*/, docRef
                    .update({
                    cycleName: cycle.cycleName,
                    categoryName: cycle.categoryName,
                    subCategoryName: cycle.subCategoryName
                })
                    .then(function () { return __awaiter(void 0, void 0, void 0, function () {
                    var cycleData, controlIds, promiseResult;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, (0, exports.get)(cycleId)];
                            case 1:
                                cycleData = _a.sent();
                                controlIds = cycleData.controlIds;
                                promiseResult = lodash_1.default.map(controlIds, function (controlId) { return __awaiter(void 0, void 0, void 0, function () {
                                    var controlData;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, ControlManager.get(controlId)];
                                            case 1:
                                                controlData = _a.sent();
                                                controlData.cycleName = cycle.cycleName;
                                                controlData.categoryName = cycle.categoryName;
                                                controlData.subCategoryName = cycle.subCategoryName;
                                                return [4 /*yield*/, firebase.dbService.collection('CONTROL').doc(controlData.id).update({
                                                        cycleName: controlData.cycleName,
                                                        categoryName: controlData.categoryName,
                                                        subCategoryName: controlData.subCategoryName
                                                    })];
                                            case 2:
                                                _a.sent();
                                                return [2 /*return*/];
                                        }
                                    });
                                }); });
                                return [4 /*yield*/, Promise.all(promiseResult)];
                            case 2:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                }); })];
            case 5:
                // 기존의 CYCLE 항목 수정
                _a.sent();
                _a.label = 6;
            case 6: return [2 /*return*/];
        }
    });
}); };
exports.update = update;
//# sourceMappingURL=CycleManager.js.map